export const CsrfErrorHelp = () => (
  <p>
    {"We need your help:"}
    <br />
    {"Please clear cache and cookies of your browser and login again. "}
    <a href="https://its.uiowa.edu/support/article/719" target="_blank" rel="noreferrer">
      Click here
    </a>
    {" for coaching tips how to do it. (You can always contact "}
    <a href="mailto:service@playerdash.app">service@playerdash.app</a>
    {" and we’ll try to help.)"}
  </p>
)
